import React from 'react';

const ItemViewHidden = () => (
  <div></div>
);

export default ItemViewHidden;
